import authConfig from './authConfig'
import bus from '@/libs/bus'
import {
    HB_AUTH_GROUP,
    HB_MAIN_GROUP,
    HB_SUB_GROUP
} from './server'

export default class AuthService {
    axiosIns = null
    authConfig = { ...authConfig }

    constructor (axiosIns, overrideConfig) {
        this.axiosIns = axiosIns
        this.authConfig = { ...this.authConfig, ...overrideConfig }
        this.axiosIns.interceptors.request.use(
            config => {
                config.headers.common = {
                    'Content-Type': 'application/json'
                }
                /** always add locale key in header. */
                const locale = this.getLocale()
                if (locale && locale !== '') {
                    config.headers.common[this.authConfig.languageKeyName] = locale
                }

                /** always namespace in header */
                if (this.authConfig.namespace) {
                    config.headers.common[this.authConfig.namespaceKeyName] = this.authConfig.namespace
                }

                /** always service-group in header */
                if (this.authConfig.serviceGroup) {
                    config.headers.common[this.authConfig.serviceGroupKeyName] = this.authConfig.serviceGroup
                }

                /** megazone pops */
                if (this.authConfig.code) {
                    config.headers.common.code = this.authConfig.code
                }

                /** CostPivot Download */
                if (this.authConfig.dataToken) {
                    config.headers.common[this.authConfig.dataTokenKeyName] = this.authConfig.dataToken
                }
                /** if login then always add token key in header  */
                const accessToken = this.getToken()
                if (accessToken) {
                    config.headers.common[this.authConfig.tokenKeyName] = accessToken
                }

                /** if specific-server reqeust then, add custom auth key in header */
                if (this.authConfig.specificAuthKeyName && this.validateSpecificKey(this.authConfig.specificAuthKeyName)) {
                    const authorizationKey = this.getAuthorizationKey()
                    config.headers.common[this.authConfig.specificAuthKeyName] = authorizationKey
                }
                /** Add service idx in header */
                if (this.authConfig.serviceIdx) {
                    config.headers.common[this.authConfig.serviceIdxKeyName] = this.authConfig.serviceIdx
                }

                config.onDownloadProgress = function (progressEvent) {
                    // console.log(progressEvent)
                    // Do whatever you want with the native progress event
                }
                if (!config.skipAutoProgress) {
                    bus.$emit('start:progress')
                }
                return config
            },
            error => Promise.reject(error)
        )
        this.axiosIns.interceptors.response.use(
            response => {
                if (!response.config.skipAutoProgress) {
                    bus.$emit('end:progress')
                }
                return response
            },
            error => {
                const baseURL = error.response?.config?.baseURL
                if (!error.config?.skipAutoProgress) {
                    bus.$emit('end:progress')
                }
                if (error.response && HB_AUTH_GROUP.includes(baseURL)) {
                    this.errorHandlerByAuthGroup(error)
                } else if (error.response && HB_MAIN_GROUP.includes(baseURL)) {
                    this.errorHandlerByMainGroup(error)
                } else if (error.response && HB_SUB_GROUP.includes(baseURL)) {
                    this.errorHandlerBySubGroup(error)
                } else {
                    bus.$emit('request:error', { title: 'Please try again later', content: error.message })
                }
                throw error
            }
        )
    }

    validateSpecificKey (key) {
        return this.authConfig.availableSpecificAuthKeyNames.includes(key)
    }

    getLocale () {
        return localStorage.getItem(this.authConfig.storageLanguageKeyName)
    }

    getToken () {
        return localStorage.getItem(this.authConfig.storageTokenKeyName)
    }

    removeToken () {
        return localStorage.removeItem(this.authConfig.storageTokenKeyName)
    }

    getAuthorizationKey () {
        const keys = this.authConfig.specificKey
        const index = Math.floor(Math.random() * keys.length)
        return keys[index]
    }
    /* error handler */
    errorHandlerByAuthGroup (error) {
        const statusCode = error.response.status
        const errorName = error.response.data && error.response.data.error
        const errorMessage = error.response.data && error.response.data.message
        if (statusCode < 500) {
            bus.$emit('request:warning', { title: errorName, content: errorMessage })
        } else {
            bus.$emit('request:error', { title: errorName, content: errorMessage })
            if (error.response.data.path.indexOf('/user-auth-resource/') > -1) {
                this.removeToken()
                window.location.href = '/'
            }
        }
        if (statusCode === 401 && errorName.toUpperCase() === 'UNAUTHORIZED') {
            if (error.response.data.path.indexOf('/auth/login/otp/billing') < 0) {
                this.removeToken()
            }
            if (error.response.data.path.indexOf('/external/auth/pops') > -1) {
                throw error
            } else if (error.response.data.path.indexOf('/auth/login/internal/') > -1) {
                window.location.href = '/'
            } else if (error.response.data.path.indexOf('/auth/login') < 0) {
                window.location.href = '/'
            }
        }
        throw error
    }
    errorHandlerByMainGroup (error) {
        const statusCode = error.response.status
        const errorStatus = error.response.data && error.response.data.status
        const errorMessage = error.response.data && error.response.data.errorMessage
        if (statusCode < 500) {
            bus.$emit('request:warning', { title: errorStatus, content: errorMessage })
        } else {
            bus.$emit('request:error', { title: errorStatus, content: errorMessage })
        }
        if (statusCode === 401 && errorStatus === 'UNAUTHORIZED') {
            this.removeToken()
            window.location.href = '/'
        }
    }
    errorHandlerBySubGroup (error) {
        const statusCode = error.response.status
        const errorName = error.response.data && error.response.data.status
        const errorMessage = error.response.data && error.response.data.message
        if (statusCode < 500) {
            bus.$emit('request:warning', { title: errorName, content: errorMessage })
        } else {
            bus.$emit('request:error', { title: errorName, content: errorMessage })
        }
        if (statusCode === 401) {
            this.removeToken()
            window.location.href = '/'
        }
    }
}
